'use strict';

export function toggleSlowAnimationsOnUIRuntime() {
  // noop
  return false;
}
//# sourceMappingURL=slowAnimations.js.map